import { ref, computed, onMounted, onUnmounted } from 'vue'

// Shared clock: one interval for however many components ask for the current time,
// so a Day/Week grid with many teacher columns doesn't spin up a timer per column.
const now = ref(new Date())
let timer = null
let subscribers = 0

export function useNow() {
  onMounted(() => {
    if (subscribers === 0) timer = setInterval(() => { now.value = new Date() }, 30000)
    subscribers++
  })
  onUnmounted(() => {
    subscribers--
    if (subscribers === 0 && timer) { clearInterval(timer); timer = null }
  })

  // Business hours run on Eastern time regardless of the viewer's own timezone.
  const nowHourFraction = computed(() => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(now.value)
    const p = Object.fromEntries(parts.map(({ type, value }) => [type, value]))
    return (+p.hour) + (+p.minute) / 60
  })

  return { now, nowHourFraction }
}
